import { render } from "./VoyagesReport.vue?vue&type=template&id=3b588ea3&scoped=true"
import script from "./VoyagesReport.vue?vue&type=script&lang=js"
export * from "./VoyagesReport.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./VoyagesReport.vue?vue&type=style&index=1&id=3b588ea3&lang=css"
import "./VoyagesReport.vue?vue&type=style&index=2&id=3b588ea3&scoped=true&lang=css"
import "./VoyagesReport.vue?vue&type=style&index=3&id=3b588ea3&lang=css"
import "./VoyagesReport.vue?vue&type=style&index=4&id=3b588ea3&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b588ea3"]])

export default __exports__